import { queryOptions, useQuery } from '@tanstack/react-query';

import type { ErrorFetch } from '@shared/api/errors';
import { handleFetch } from '@shared/api/http';

import type { PubSettings } from './types.gen';

export const optionsSettings = () =>
  queryOptions<PubSettings, ErrorFetch | Error>({
    queryKey: ['settings'],
    queryFn: () => handleFetch<PubSettings>({ url: '/settings' }),
    retry: false,
    staleTime: 300_000,
  });

export const useSettings = () => useQuery(optionsSettings());
